<template>
  <div v-if="restaurant" id="restaurant" class="mb-md-16 content-wrapper">
    <v-container>
      <h1 class="mb-5 text-center">Restaurant</h1>
      <v-row>
        <v-col class="mb-5 pb-0" cols="12" md="6">
          <div class="bordered pb-2 ps-5">
            <h4 class="mb-5">Kontakt</h4>
            <p v-if="restaurant.contactName" class="font-weight-bold">Familie Christou</p>
            <p v-if="restaurant.contactStreet">Lange Straße 32</p>
            <p v-if="restaurant.contactPlace" class="mb-3">38448 Wolfsburg / Vorsfelde</p>
            <p v-if="restaurant.contactPhone">Tel.: 05363 - 975348</p>
          </div>
        </v-col>
        <v-col class="mb-5 pb-0" cols="12" md="6">
          <div v-if="restaurant.image" class="pt-2 pb-2">
            <v-img
                :src="restaurant.image.src"
                :alt="restaurant.image.alt"
                cover
                eager
                height="300"
            >
              <template v-slot:placeholder>
                <div class="d-flex align-center justify-center fill-height">
                  <v-progress-circular
                      color="#573720"
                      indeterminate
                  />
                </div>
              </template>
            </v-img>
          </div>
        </v-col>
        <v-col class="pb-0" cols="12">
          <div class="bordered pb-2 ps-5">
            <h4 class="mb-5">Historischer Hintergrund</h4>
            <p v-if="restaurant.historicalBackground" style="white-space: pre-line">
              {{ restaurant.historicalBackground }}
            </p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "RestaurantView",
  computed: {
    ...mapGetters([
      'restaurant'
    ])
  },
  methods: {
    async getStrapi() {
      this.$store.dispatch("getRestaurant");
    }
  },
  created() {
    this.getStrapi();
  }
}
</script>